import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';

/**
 * FieldWrapper Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Props passed by backend
     */
    @Prop() props!: any;

    /**
     * Label
     */
    @Prop() label!: string;

    /**
     * Label For
     */
    @Prop() labelFor!: string;

    /**
     * Hide Label of the field
     */
    @Prop({ type: Boolean }) noLabel!: boolean;

    /**
     * Required Character
     */
    @Prop({ default: '*' }) requiredCharacter!: string;
}

export default Props;
